import { render, staticRenderFns } from "./ListFabricantesPage.vue?vue&type=template&id=56184628"
import script from "./ListFabricantesPage.vue?vue&type=script&lang=js"
export * from "./ListFabricantesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports